import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_PASSWORD_ENCRIPTION_KEY || "FILENOWAPPSECRETKEYPASSCODE";

export function encryptData(plainText) {
  return CryptoJS.AES.encrypt(plainText, secretKey).toString();
}

export function decryptData(cipherText) {
  try {
    return CryptoJS.AES.decrypt(cipherText, secretKey).toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("Decryption failed:", err);
    return "";
  }
}
